import { css } from 'styled-components';
import { commonTheme } from './common-theme';
import { colors } from '../../atoms/colors/colors';
import { ModalTags } from './class-name-tags';
export const modalLightTheme = {
    ...commonTheme,
    overlay: css `
    ${commonTheme.overlay}
  `,
    base: css `
    ${commonTheme.base}
    &.${ModalTags.content} {
      background-color: ${colors.white};
    }
  `,
};
//# sourceMappingURL=light-theme.js.map